export default {
    SUBMIT_FEEDBACK_LOADING: "SUBMIT_FEEDBACK_LOADING",
    SUBMIT_FEEDBACK_STATUS: "SUBMIT_FEEDBACK_STATUS",
    RESET_SUBMIT_FEEDBACK_STATUS: "RESET_SUBMIT_FEEDBACK_STATUS"
}
